export default __webpack_public_path__ + "static/media/indexexchange-logo.3af98124.svg";